export default __webpack_public_path__ + "static/media/3d_icon.a163b3d8.svg";